import React, { lazy } from 'react';
import { ArrowRight } from 'lucide-react';
export function ProjectShowcase() {
  const projects = [{
    img: 'https://cdn.magicpatterns.com/uploads/pbamvRtDcRZnZ8JGHbyjTW/commercialpic9.webp',
    tag: 'Shopping Centers & Malls',
    title: 'Mall Storefront Glazing',
    copy: 'Tempered glass storefronts, sliding entry systems and display windows for retail tenants.',
    alt: "Commercial mall storefront glass installation by Kosin's Glass"
  }, {
    img: 'https://cdn.magicpatterns.com/uploads/mhAwMYoGqDPrBMryYyNXUJ/comertialpic7.webp',
    tag: 'Medical & Healthcare',
    title: 'Healthcare Facility Glazing',
    copy: 'Curtain walls, entrances and large architectural glass for hospitals and medical centers.',
    alt: 'Commercial medical center glass facade with curtain wall glazing'
  }, {
    img: 'https://cdn.magicpatterns.com/uploads/tkhR2Xd82w84KS5fiqyWsG/comertialpic5.webp',
    tag: 'Hotels & Hospitality',
    title: 'Hotel & Resort Glass',
    copy: 'Lobby entrances, guest-facing windows and exterior glazing for hotels and hospitality buildings.',
    alt: 'Commercial hotel exterior with glass entrance and windows'
  }, {
    img: 'https://cdn.magicpatterns.com/uploads/4QfighLHoVco1NmZyDkSnQ/comertialpic2.webp',
    tag: 'Grocery & Retail',
    title: 'Retail & Grocery Storefronts',
    copy: 'Storefront systems, automatic entrances and replacement glass for grocery and retail buildings.',
    alt: 'Commercial grocery store storefront glass and entrance'
  }];
  return <section className="py-20 bg-white border-t border-neutral-200" data-id="element-229">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-230">
        <div className="text-center max-w-3xl mx-auto mb-14" data-id="element-231">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-md bg-primary-50 text-primary-700 text-xs font-semibold uppercase tracking-wider mb-4 font-sans" data-id="element-232">
            Featured Project Types
          </div>
          <h2 className="kosins-heading text-4xl md:text-5xl text-neutral-900 mb-4" data-id="element-233">
            Commercial Glass Across Every Type of Building
          </h2>
          <p className="text-lg text-neutral-600 font-sans" data-id="element-234">
            From retail storefronts and shopping centers to healthcare,
            hospitality and grocery, Kosin's Glass delivers commercial glazing
            built for daily commercial use.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-235">
          {projects.map((p, idx) => <article key={idx} className="group relative rounded-md overflow-hidden border border-neutral-200 bg-white shadow-sm hover:shadow-lg transition-shadow" data-id="element-236">
              <div className="relative aspect-[16/10] overflow-hidden bg-neutral-100" data-id="element-237">
                <img src={p.img} alt={p.alt} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" data-id="element-238" />
                <div className="absolute top-3 left-3 bg-white/95 backdrop-blur-sm px-3 py-1 rounded-sm" data-id="element-239">
                  <span className="text-[11px] uppercase tracking-widest text-primary-600 font-semibold font-sans" data-id="element-240">
                    {p.tag}
                  </span>
                </div>
              </div>
              <div className="p-6" data-id="element-241">
                <h3 className="kosins-heading text-2xl text-neutral-900 mb-2" data-id="element-242">
                  {p.title}
                </h3>
                <p className="text-neutral-600 text-sm leading-relaxed font-sans" data-id="element-243">
                  {p.copy}
                </p>
              </div>
            </article>)}
        </div>

        <div className="text-center mt-12" data-id="element-244">
          <button onClick={() => window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })} className="inline-flex items-center gap-2 bg-primary-600 hover:bg-primary-700 text-white font-semibold py-3.5 px-8 rounded-md transition-colors uppercase tracking-wider text-sm group" data-id="element-245">
            Request a Free Commercial Estimate
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-246" />
          </button>
        </div>
      </div>
    </section>;
}